module.exports = __webpack_public_path__ + "img/class_c.cb91010c.jpg";